<template>
  <div v-if="show" class="account-dialog-overlay" tabindex="-1">
    <div class="account-dialog">
      <h2 class="dialog-title">Enter Login Code</h2>
      <h4 class="dialog-info-instructions">Please enter the login code that was emailed to you below. If you don't see it, check your spam folder.</h4>
      <div v-if="error" class="dialog-error-message">
        {{ error }}
      </div>
      <form @submit.prevent="$emit('submit')">
        <div class="dialog-form-group">
          <input id="login-verification-code" v-model="code" type="text" maxlength="6" required 
                 autocomplete="one-time-code" class="dialog-input"
                 @input="onInput"
                 pattern="[0-9]{6}"
                 title="Invalid verification code" />
        </div>
        <div class="dialog-actions">
          <button class="dialog-cancel-btn" type="button" @click="$emit('close')" :disabled="isLoading">Cancel</button>
          <button class="dialog-save-btn" type="submit" :disabled="isLoading">
            <span v-if="!isLoading">Submit</span>
            <span v-else class="spinner"></span>
          </button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
export default {
  name: 'LoginVerificationDialog',
  props: {
    show: { type: Boolean, required: true },
    isLoading: { type: Boolean, default: false },
    error: { type: String, default: '' },
    codeValue: { type: String, default: '' }
  },
  emits: ['close', 'submit', 'update:codeValue'],
  data() {
    return {
      code: this.codeValue
    };
  },
  watch: {
    codeValue(newVal) {
      this.code = newVal;
    },
    code(newVal) {
      this.$emit('update:codeValue', newVal);
    }
  },
  methods: {
    onInput(e) {
      this.code = e.target.value;
    }
  }
};
</script>

<style scoped>
</style>
